import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Label, Menu, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

export enum longtermCarePlanMenuTab {
  TAB1 = `Types of Facilities`,
  TAB2 = `Costs of Care`,
  TAB3 = `Long-Term Care Insurance`
}

export const LongTermCarePlanLearnMore: React.FC = () => {
  const [activeLearnMoreMenuItem, setActiveLearnMoreMenuItem] = useState(longtermCarePlanMenuTab.TAB1);
  const [activeAccordionIndexes] = useState([0,1,2,3,4]);const renderAccordionUnderstanding = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <p className={styles.learnMoreAccordionText} > 
          Visiting several long-term care and assisted living facilities provides the opportunity to compare and ask questions of staff and residents. We encourage you to contact the ones of interest to identify the most suitable ones to visit. You will need to think about what is important in a facility, such as the location, size, and types of services.
          <br/><br/>          
          It is always a good idea to request a copy of a contract. It is not a good sign if a facility will not provide a contract until a potential resident is ready to sign. You should never sign a contract the day of the visit.
          <br/><br/>
          Most older adults prefer living in the home they have enjoyed for years, even when they need long-term care. Communities are increasingly developing programs and services to facilitate “aging in place.” As you think about long-term care, consider not only facilities, but also the possibility the older adult can live safely in their own home with a variety of community supports.  
          <br/><br/>
          <span className={styles.learnMoreAccordionTextEmphasis} > 
            Before deciding about a facility, it is important to take the contract home and review it thoroughly, preferably 
            with a lawyer and knowledgeable family members. </span> 
        </p>
      </Segment>
      </>
    );
  };
  const displayActiveMenuSection = () => {
      switch(activeLearnMoreMenuItem) {
        case longtermCarePlanMenuTab.TAB1:  
          return renderMenuTab1();
        case longtermCarePlanMenuTab.TAB2:  
          return renderMenuTab2();
        case longtermCarePlanMenuTab.TAB3:  
          return renderMenuTab3();
    }
  };
  const renderMenuTab1 = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded >
        <Grid.Column >
          <Header className={styles.learnMoreBulletedListHeader} > Nursing Homes </Header>
          <p className={styles.learnMoreAccordionText} > 
          Nursing homes, also called skilled nursing facilities, focus more on medical care than do assisted living facilities. Nursing homes typically include nursing care, 24-hour supervision, three meals a day, and assistance with everyday activities.
          </p>
          <p className={styles.learnMoreAccordionText} > 
          Rehabilitation services, such as physical, occupational, and speech therapy, are also available.Usually, people must pay for nursing home care themselves. Medicare generally doesn’t cover long-term stays in a nursing home, but it may pay for some related costs, such as doctor services and medical supplies. Medicaid may cover some of the costs of nursing homes for low-income people.
          </p>
          <p className={styles.learnMoreAccordionText}>If the older person has long-term care insurance, the policy may include some coverage for nursing home care. Check with the insurance company for details.</p>
        </Grid.Column>
        <Grid.Column >     
          <Header className={styles.learnMoreBulletedListHeader} > Retirement Communities (CCRCs) </Header>     
          <p className={styles.learnMoreAccordionText} > 
          These facilities offer different levels of service in one location. Many offer independent housing (in houses or apartments), assisted living, memory care, and skilled nursing care, all on one campus. Health care services and recreation programs are also provided.</p>
          <p className={styles.learnMoreAccordionText}  style={{marginBottom: '1rem'}}> 
          In a CCRC, you progress from one level of care to another when your needs for help increase, all while remaining in the same facility. People often enter CCRCs with only minimal needs and live in independent living units or assisted living units.  As their needs increase, they can transfer to the memory care or nursing home part of the facility.</p>
          <p className={styles.learnMoreAccordionText}  style={{marginBottom: '1rem'}}>Most CCRCs charge a one-time entrance fee, which may be relatively expensive, and a monthly fee after that. People must pay most of these costs themselves. Medicare, Medicaid, and long-term care insurance may cover some services, depending on the level of care provided.</p>
        </Grid.Column>
        <Grid.Column >  
          <Header className={styles.learnMoreBulletedListHeader} > Assisted Living </Header>    
            <p className={styles.learnMoreAccordionText}>Assisted living is for people who need help with daily care, but not as much help as a nursing home provides. Assisted living facilities range in size from as few as 25 residents to 100 or more. Typically, several levels of care are offered, and residents pay more if they need extra services or special care. 
            </p>
            <p className={styles.learnMoreAccordionText}>Assisted living residents live in their own apartments or rooms and share common areas. They typically have access to up to three meals a day, assistance with personal care, help with medications, housekeeping, and laundry, 24-hour supervision, security, and on-site staff, and social and recreational activities.
            </p>
            <p className={styles.learnMoreAccordionText}>Most people pay the full costs of assisted living themselves. This option tends to be more expensive than living independently but less expensive than a nursing home. Medicare does not pay for assisted living. Medicaid may provide coverage for some aspects of assisted living, depending on the state and whether the person is eligible. This care option is partially covered by some long-term care insurance policies.</p>
        </Grid.Column>
      </Grid>
      </>
    );
  };
  const renderMenuTab2 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}}  > 
        As the older adult ages, they may no longer be able to live independently. There are different types of 
        residential facilities that are designed to offer varying levels of personal and medical care. Home care 
        organizations also provide medical and personal care within the older adult's home on a short-term or 
        long-term basis. </p>
      <p className={styles.learnMoreAccordionText} > 
        Many people don't think of the costs associated with long-term care until it is too late. It is important 
        to understand the potential costs and to develop a plan with this scenario in mind. </p>
      <p className={styles.learnMoreAccordionTextEmphasis} >        
        The costs and payment options available are dependent on the facility and the financial situation of the 
        older adult. </p>        
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}} > 
        There are options available to cover these expenses such as Medicare, Medicaid, some veterans' benefits, 
        long-term care insurance, and private funding. </p>
      </>
    );
  };
  const renderMenuTab3 = () => {
    return (
      <>
      <p className={styles.learnMoreAccordionText} style={{marginTop: '2rem'}}  > 
        Many older adults will need long-term care services at some point in their lives. Long-term care can 
        include residential facilities, but it also includes in-home care including help with daily activities 
        and things like physical and occupational therapy. These services can be expensive and traditional 
        insurance and Medicare does not usually cover the cost. </p>
      <p className={styles.learnMoreAccordionText} > 
        <b> Long-term care insurance can help to pay for these services should the older adult need  them. </b> It 
        is important to look into this before the older adult needs long-term care. A typical policy will pay out a 
        predetermined amount for each service. </p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '2rem'}} > 
        <b>Traditional long-term care insurance</b> requires a monthly premium for coverage, which the older adult 
        may or may not end up using. <b>Hybrid long-term care/life insurance</b> is also an option where if older 
        adult ends up needing care, the costs will come out of the death benefit. If not, the death benefit will 
        remain as it is. </p> 
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '2rem'}}>Long-term care insurance can help to pay for these services should the older adult need them. It is important to look into this before the older adult needs long-term care. A typical policy will pay out a predetermined amount for each service.</p>
      <p className={styles.learnMoreAccordionText} style={{marginBottom: '3rem'}}>Traditional long-term care insurance requires a monthly premium for coverage, which the older adult may or may not end up using. Hybrid long-term care/life insurance is also an option. If the older adult ends up needing care, the costs will come out of the death benefit. If not, the death benefit will remain as it is.</p>
</>
    );
  };
  
  const accordions = [
    { key: 'understanding',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Home Care Options </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionUnderstanding()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}Caregiver3.jpeg)`, }}>
        <div className={styles.learnMoreModalContent}  >

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

          <div className={styles.learnMoreMenuDiv} >
            <Segment.Group raised className={styles.learnMoreMenuSegmentGroup} >
              <Menu attached='top' tabular color="green" className={styles.learnMoreMenuTab} widths='four'>
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB1}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB1}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB1)}
                />
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB2}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB2}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB2)}
                >Costs of Care</Menu.Item>
                <Menu.Item
                  name={longtermCarePlanMenuTab.TAB3}
                  active={activeLearnMoreMenuItem === longtermCarePlanMenuTab.TAB3}
                  onClick={() => setActiveLearnMoreMenuItem(longtermCarePlanMenuTab.TAB3)}
                >Long-Term Care Insurance</Menu.Item>
              </Menu>
              <Segment attached='bottom' raised className={styles.learnMoreMenuTabbedSegment} >
                {displayActiveMenuSection()}
              </Segment>
            </Segment.Group>
          </div> 
    
        </div>
      </Segment>    
    </>
    );  
};
